const formats = [
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Адаптация отдела продаж',
    desc: 'Специализированная программа для менеджеров по продажам. Включает книгу продаж, скрипты, обучение продукту, стажировку с наставником и выход на план продаж за 4-6 недель.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Адаптация руководителей',
    desc: 'Онбординг для управленцев: знакомство с командой, стратегией, KPI подразделения. Программа длится 3-6 месяцев и включает наставничество от вышестоящего руководителя.',
  },
  {
    icon: 'ri-computer-line',
    title: 'Адаптация офисных сотрудников',
    desc: 'Универсальная программа для бэк-офиса: бухгалтерия, маркетинг, HR, административный персонал. Чек-листы, база знаний, welcome-пакет и регулярная обратная связь.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Адаптация производственного персонала',
    desc: 'Программа с акцентом на технику безопасности, стандарты качества и работу с оборудованием. Наставник из числа опытных рабочих сокращает время обучения на производстве в 2 раза.',
  },
  {
    icon: 'ri-global-line',
    title: 'Онлайн-онбординг',
    desc: 'Адаптация удалённых сотрудников: видеозвонки-знакомства, электронные чек-листы, доступ к базе знаний, регулярные онлайн-встречи с руководителем и командой.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Корпоративная академия',
    desc: 'Создание внутреннего центра обучения и развития персонала. Объединяет адаптацию, обучение новым навыкам, развитие руководителей и управление знаниями компании.',
  },
];

export default function Formats() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Форматы внедрения системы адаптации
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Адаптация не бывает «одной на всех». Мы разрабатываем программы под конкретные категории сотрудников — потому что онбординг продавца принципиально отличается от адаптации руководителя.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {formats.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-300 transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}